import {
  Component,
  inject,
  OnInit,
  input,
  output
} from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import {
  IconButtonDirective,
  WcgErrorComponent,
} from '@wcg/frontend-framework';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentType, RequiredDocumentType } from '@documents/models';
import { findDocumentType } from '@data-access/submissions/utils/find-document-type.util';
import { findRequiredDocumentType } from '@submissions/v1/content/documents-sections/utils/documents-sections.utils';
import { NgClass } from '@angular/common';
@Component({
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    WcgErrorComponent,
    IconButtonDirective,
    MatTooltipModule,
    NgClass
  ],
  selector: 'wcg-upload-file-row',
  styleUrls: ['./upload-file-row.component.scss'],
  templateUrl: './upload-file-row.component.html',
})
export class WcgUploadFileRowComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);

  readonly errorMessage = input('');
  readonly documentTypes = input<DocumentType[]>([]);
  readonly requiredTypesForSubmission = input<RequiredDocumentType[]>([]);
  readonly documentNameInput = input('');
  readonly requiredDocument = input<RequiredDocumentType>({} as RequiredDocumentType);
  readonly isLast = input(false);
  readonly isRequired = input(false);

  readonly handleDeleteFile = output<void>();
  dropdownOptions: string[] = [];
  fileControl: FormControl = new FormControl();

  fileForm?: FormGroup;

  get fileName() {
    return this.file?.value?.name;
  }

  get file() {
    return this.fileForm?.get('file');
  }

  get documentType() {
    return this.fileForm?.get('documentType');
  }

  get documentName() {
    return this.fileForm?.get('documentName');
  }

  get questionId() {
    return this.fileForm?.get('questionId');
  }

  ngOnInit() {
    this.fileForm = this._controlContainer.control as FormGroup;
    const requiredDocument = this.requiredDocument();
    if (requiredDocument?.document_type) {
      this.fileForm.patchValue({
        documentType: requiredDocument?.document_type?.name ?? '',
        documentName: requiredDocument?.document_type?.title ?? 'N/A',
      });
    } else {
      const reqDoc = findRequiredDocumentType(
        this.requiredDocument?.name ?? '',
        this.requiredTypesForSubmission(),
      );
      this.fileForm.patchValue({
        documentType: requiredDocument?.name ?? '',
        documentName: reqDoc?.document_type.title ?? 'N/A',
      });
    }
  }

  deleteFile() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.handleDeleteFile.emit();
  }

  onDocumentTypeChange() {
    // First find the document type to get its ID
    const documentType = findDocumentType(
      this.documentType?.value,
      this.documentTypes(),
    );

    // Then find the required document type using the ID
    const requiredDocumentType = findRequiredDocumentType(
      documentType?.id ?? '',
      this.requiredTypesForSubmission(),
    );

    // Set the document name from the required document type
    this.fileForm
      ?.get('documentName')
      ?.setValue(requiredDocumentType?.document_type.title ?? 'N/A');
  }

  hasMatchingDocumentType(): boolean {
    const selectedDocumentType = this.fileForm?.get('documentType')?.value;
    return this.requiredTypesForSubmission().some(
      (doc) => doc.document_type.name === selectedDocumentType,
    );
  }
}
